import { CommonFunctions } from '../static/common-functions';
import { InvoiceService } from '../services/invoice.service';
import { Subscription } from 'rxjs';
import { AttachmentBus } from "./AttachmentBus";
import { v_InvoiceEquipmentBus } from './v_InvoiceEquipmentBus';
import { BasePage } from './BasePage';
import { StatusHistoryBus } from './StatusHistoryBus';
import { DisplayNote } from './DisplayNote';
//import { CDK_CONNECTED_OVERLAY_SCROLL_STRATEGY } from '@angular/cdk/overlay/typings/overlay-directives';
import { BaseMessageInfo } from './BaseMessageInfo';
import { InvoiceCollectionNotesBus } from './InvoiceCollectionNotesBus';
import { ChangeDetectorRef } from '@angular/core';
import { CommonValues } from '../static/CommonValues';
import { GItem } from './GItem';

export class InvoicePage extends BasePage<InvoiceService>
{
  svc_data: InvoiceService;
  constructor(svc_data: InvoiceService, data: InvoicePage = null, cd: ChangeDetectorRef = null)
  {
      super();
    this.svc_data = svc_data;
    if (data !== null) {
//      this.dispatchId = data.dispatchId;
    }
  }
    cd: ChangeDetectorRef;
    detectChanges() {
        //if (this.cd) {
        //    this.cd.detectChanges();
        //}
    }
 clear() {
     this.unsubscribe();
     this.id = null;
     this.attachments = null;
     this.invoiceEquipment = null;
     this.statusHistory = null;
     this.collectionNotes = null;
     this.relatedInvoices = null;
     this.attachmentsLoading = false;
     this.invoiceEquipmentLoading = false;
     this.statusHistoryLoading = false;
     this.collectionNotesLoading = false;
     this.relatedInvoicesLoading = false;
 }
  unsubscribe() {
    CommonFunctions.unsubscribe(this.subs_attachments);
    CommonFunctions.unsubscribe(this.subs_invoiceEquipment);
      CommonFunctions.unsubscribe(this.subs_statusHistory);
      CommonFunctions.unsubscribe(this.subs_collectionNotes);
  }

  subs_attachments: Subscription;
  subs_invoiceEquipment: Subscription;
    subs_statusHistory: Subscription;
    subs_collectionNotes: Subscription;
    subs_relatedInvoices: Subscription;

  getAttachments(id: any) {
      if (CommonFunctions.hasGuidValue(id)) {
          this.attachmentsLoading = true;
          CommonFunctions.unsubscribe(this.subs_attachments);
          this.subs_attachments = this.svc_data.getAttachments(id).subscribe(data => {
              let arr = [];
              if (CommonFunctions.hasArrayElementValue(data)) {
                  for (let i = 0; i < data.length; i++) {
                      let busObj: AttachmentBus = new AttachmentBus(data[i]);
                      arr.push(busObj);
                  }
              }
              this.attachments = arr;
              this.attachmentsLoading = false;
              this.detectChanges();
          });
      }
  }
    getInvoiceEquipment(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.invoiceEquipmentLoading = true;
            CommonFunctions.unsubscribe(this.subs_invoiceEquipment);
            this.subs_invoiceEquipment = this.svc_data.getInvoiceEquipment(id).subscribe(data => {
                this.setEquipment(data);
                this.invoiceEquipmentLoading = false;
            });
        }
    }
    getStatusHistory(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.statusHistoryLoading = true;
            CommonFunctions.unsubscribe(this.subs_statusHistory);
            this.subs_statusHistory = this.svc_data.getStatusHistory(id).subscribe(data => {
                this.statusHistory = data;
                this.statusHistoryLoading = false;
                this.detectChanges();
            });
        }
    }
    wasEverStatus(statusId: string) : boolean {
        let wasEver = false;
        if (this.hasStatusHistory) {
            let status = this.statusHistory.find(s => s.statusId == statusId);
            if (CommonFunctions.hasValue(status)) {
                wasEver = true;
            }
        }
        return wasEver;

    }
    getCollectionNotes(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.collectionNotesLoading = true;
            CommonFunctions.unsubscribe(this.subs_collectionNotes);
            this.subs_collectionNotes = this.svc_data.getCollectionNotes(id).subscribe((info: BaseMessageInfo) => {
                if (!info.saveError) {
                    let data = info.primaryReturn;
                    let arr = [];
                    if (CommonFunctions.hasArrayElementValue(data)) {
                        for (let i = 0; i < data.length; i++) {
                            let busObj: InvoiceCollectionNotesBus = new InvoiceCollectionNotesBus(data[i]);
                            arr.push(busObj);
                        }
                    }
                    this.collectionNotes = arr;
                    console.log("invpage-collnotes: ", arr, info);
                    this.detectChanges();
                    
                }
                this.collectionNotesLoading = false;
            });
        }
    }
    getRelatedInvoices(id: any) {
        if (CommonFunctions.hasGuidValue(id)) {
            this.relatedInvoicesLoading = true;
            CommonFunctions.unsubscribe(this.subs_relatedInvoices);
            this.subs_relatedInvoices = this.svc_data.getRelatedInvoices(id).subscribe((info: BaseMessageInfo) => {
                this.relatedInvoices = info.primaryReturn;
                this.relatedInvoicesLoading = false;
                this.detectChanges();
            });
        }
    }

  id: any;
  attachments: AttachmentBus[];
  invoiceEquipment: v_InvoiceEquipmentBus[];
  statusHistory: StatusHistoryBus[];
    collectionNotes: InvoiceCollectionNotesBus[];
    relatedInvoices: GItem[];

    attachmentsLoading: boolean = false;
    invoiceEquipmentLoading: boolean = false;
    statusHistoryLoading: boolean = false;
    collectionNotesLoading: boolean = false;
    relatedInvoicesLoading: boolean = false;

    get hasRelatedInvoices(): boolean {
        return CommonFunctions.hasValue(this.relatedInvoices) || this.relatedInvoicesLoading;
    }
  get hasAttachments(): boolean {
      return CommonFunctions.hasValue(this.attachments) || this.attachmentsLoading;
  }
  get hasInvoiceEquipment(): boolean {
        return CommonFunctions.hasValue(this.invoiceEquipment) || this.invoiceEquipmentLoading;
  }
    get hasStatusHistory(): boolean {
        return CommonFunctions.hasValue(this.statusHistory) || this.statusHistoryLoading;
    }
    get hasCollectionNotes(): boolean {
        return CommonFunctions.hasValue(this.collectionNotes) || this.collectionNotesLoading;
    }

    setEquipment(data: v_InvoiceEquipmentBus[]) {
        let arr = [];
        if (CommonFunctions.hasArrayElementValue(data)) {
            for (let i = 0; i < data.length; i++) {
                let busObj: v_InvoiceEquipmentBus = new v_InvoiceEquipmentBus(data[i]);
                arr.push(busObj);
            }
        }
        this.invoiceEquipment = arr;
    }
    afterPrimarySaved(id: any) {
        this.getStatusHistory(id);
        this.getAttachments(id);
        if (this.hasRelatedInvoices) {
            this.getRelatedInvoices(id);
        }
        if (this.hasCollectionNotes) {
            this.getCollectionNotes(id);
        }
    }
}
